<script setup>
// eslint-disable-next-line no-unused-vars
  const props = defineProps({
    name: {
      type: String,
      required: true
    },
  })
</script>

<template>
  <img
    alt="Icon"
    :src="`/images/icons/${name}.svg`"
  >
</template>

<style scoped>

</style>
